<div class="image-asset" [ngClass]="useBorder ? 'border' : ''" [ngStyle]="{'width': scaleToFitContainer ? '100%' : width + 'px', 'height': scaleToFitContainer ? '100%' : height + 'px'}">

    <div class="image-asset-spinner" [ngClass]="setSpinnerClass()">
        <p-progressSpinner strokeWidth="8" animationDuration="1s" [hidden]="!loading"></p-progressSpinner>
    </div>

    <div class="image-area" *ngIf="!loading" [ngStyle]="{ 'background-image': 'url(' + url + ')'}" >
    </div>

    <p-checkbox *ngIf="imageAsset?.AssetType === AssetType.Image && allowImageSelection" class="image-asset-checkbox" label="" binary="true" [(ngModel)]="imageAsset.Selected"
                (onChange)="onImageAssetSelected()" (click)="onSelectionCheckboxClicked($event)">
    </p-checkbox>
</div>
